import { useUser } from '@/shared/hooks/useAuth';
import {
  aiAttributionOf,
  type AIAuthorityUser,
  type AIAttributionKind,
} from '../authority';

const ATTRIBUTION_PREFIX: Record<AIAttributionKind, string> = {
  generation: 'Generated for',
  'workflow-run': 'Run by',
  'activity-entry': 'Activity by',
};

interface AIAttributionProps {
  kind: AIAttributionKind;
  subject?: AIAuthorityUser | null;
}

/**
 * Tier-safe attribution for generated content, workflow runs, and AI activity.
 * Presentation is a UI hint only; server guards remain authoritative.
 */
export function AIAttribution({ kind, subject }: AIAttributionProps) {
  const currentUser = useUser();
  const resolved = aiAttributionOf(subject ?? currentUser, kind);

  return (
    <p
      className="mt-2 text-label-sm text-on-surface-variant"
      data-ai-attribution={kind}
      data-authority-tier={resolved.tier}
    >
      {ATTRIBUTION_PREFIX[kind]} {resolved.attribution}
    </p>
  );
}